import { z } from "zod";

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/// URL search params for `/$workspaceSlug/payroll/salaries` (CTC redesign).
///
/// `member` opens one person's salary drawer (breakup + revision history), so a
/// link to "Priya's salary" is a link somebody can send. `q` is the grid search.
/// `filter` narrows to people who still have no salary, which is the list an
/// admin works through during first setup. `coverCycle` pre-fills effective
/// dates when a run needs salaries to cover an earlier month. No amount is ever
/// a search param.
export const payrollSalariesRouteSearchSchema = z
  .object({
    member: z.string().optional(),
    q: z.string().optional(),
    filter: z.enum(["all", "missing"]).optional(),
    coverCycle: z.string().regex(ISO_DATE).optional(),
  })
  .strict();

export type PayrollSalariesRouteSearch = z.infer<typeof payrollSalariesRouteSearchSchema>;
